"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useTheme3 = _interopRequireDefault(require("../../styles/useTheme"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme3["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      paddingLeft: spacing(4),
      flexWrap: 'wrap'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme3["default"]];
});

var ContractType = function ContractType(props) {
  var t = (0, _useTranslation["default"])();

  var _useTheme2 = (0, _useTheme3["default"])(),
      spacing = _useTheme2.spacing;

  var isLoading = (0, _useIsLoading["default"])();
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], {
    css: classes.root
  }, (0, _core.jsx)(_Text["default"], null, isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    width: spacing(10)
  }) : t('temp_work_mission')));
};

__signature__(ContractType, "useTranslation{t}\nuseTheme{{ spacing }}\nuseIsLoading{isLoading}\nuseStyles{classes}", function () {
  return [_useTranslation["default"], _useTheme3["default"], _useIsLoading["default"], useStyles];
});

var _default = ContractType;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/ContractType.tsx");
  reactHotLoader.register(ContractType, "ContractType", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/ContractType.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/ContractType.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();